/**
 * Detects if user platform is MacOS
 * @returns {boolean}
 */
export function isMacintosh() {
  return window.navigator.userAgent.indexOf('Mac') > -1;
}
